import React from 'react';
import { useResolvedPath, useMatch, NavLink, useLocation, matchPath } from 'react-router-dom'; // Asegúrate de que matchPath esté aquí
import Menu from './../../config/app-menu.jsx'; // Asegúrate de que esto esté importando el nuevo componente
import { Icon } from '@iconify/react'; // Asegúrate de que Icon esté importado

function NavItem({ menu, ...props }) {
  let path = (menu.path) ? menu.path : '';
  let resolved = useResolvedPath(path);
  let match = useMatch({ path: resolved.pathname });
  let location = useLocation();

  if (menu.is_header) {
    return <div className="menu-header">{menu.text}</div>;
  }

  if (menu.is_divider) {
    return <div className="menu-divider"></div>;
  }

  let match2 = matchPath({ path: path, end: false }, location.pathname);
  let icon = menu.icon && <div className="menu-icon"><Icon icon={menu.icon} /></div>;
  let text = menu.text && <div className="menu-text">{menu.text}</div>;

  return (
    <div className={'menu-item' + ((match || match2) ? ' active' : '') + (menu.children ? ' has-sub' : '')}>
      <NavLink className="menu-link" to={menu.path} {...props}>
        {icon} {text}
      </NavLink>
      {menu.children && (
        <div className="menu-submenu">
          {menu.children.map((submenu, i) => (
            <NavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
}

function SidebarNav() {
  const menus = Menu(); // Llama a la función que devuelve el menú actualizado

  return (
    <div className="menu">
      {menus.filter(menu => menu.isVisible !== false).map((menu, i) => (
        <NavItem key={i} menu={menu} />
      ))}
    </div>
  );
}

export default SidebarNav;